import React from 'react';
import { Zap, Cpu, BrainCircuit, Activity, ArrowRight } from 'lucide-react';
import './InfrastructureDiagram.css';

const InfrastructureDiagram = () => {
  return (
    <div className="diagram-wrapper glass">
      <div className="diagram-header">
        <span className="diagram-badge">System Architecture</span>
        <h3 className="diagram-title">The Closed-Loop Infrastructure-AI Cycle</h3>
        <p className="diagram-subtitle">
          How physical energy constraints, compute infrastructure, and temporal AI optimization interact in real time.
        </p>
      </div>

      <div className="diagram-flow">
        {/* Node 1: Physical Infrastructure */}
        <div className="diagram-card node-energy">
          <div className="card-icon-wrapper energy-bg">
            <Zap className="card-icon" />
          </div>
          <h4>1. Physical Energy Infrastructure</h4>
          <p className="node-desc">
            Power Generation (Renewables, Thermal) • Natural Gas Pipelines • Grid Transmission Nodes
          </p>
          <div className="node-stats">
            <span className="stat-pill">Sub-Second Load Waves</span>
            <span className="stat-pill">Spatio-Temporal Constraints</span>
          </div>
        </div>

        {/* Connector 1 */}
        <div className="flow-arrow">
          <div className="arrow-line energy-line"></div>
          <ArrowRight className="arrow-icon" />
          <span className="flow-label">Energy Supply & Thermal Limits</span>
        </div>

        {/* Node 2: Data Centers & Compute */}
        <div className="diagram-card node-compute">
          <div className="card-icon-wrapper compute-bg">
            <Cpu className="card-icon" />
          </div>
          <h4>2. Data Centers & Compute Layer</h4>
          <p className="node-desc">
            Hyper-scale GPU Clusters • Real-Time Inference Servers • High-Performance Workload Dispatch
          </p>
          <div className="node-stats">
            <span className="stat-pill">GW-Scale Power Draw</span>
            <span className="stat-pill">Dynamic Thermal Envelope</span>
          </div>
        </div>

        {/* Connector 2 */}
        <div className="flow-arrow">
          <div className="arrow-line compute-line"></div>
          <ArrowRight className="arrow-icon" />
          <span className="flow-label">Real-Time Workload Dynamics</span>
        </div>

        {/* Node 3: The Intelligence Layer */}
        <div className="diagram-card node-ai highlight-node">
          <div className="card-icon-wrapper ai-bg">
            <BrainCircuit className="card-icon" />
          </div>
          <h4>3. Intelligence & Optimization Layer</h4>
          <p className="node-desc">
            Physics-Informed SSMs • Dynamical Graph Neural Control • Spatio-Temporal Market Intelligence
          </p>
          <div className="node-stats">
            <span className="stat-pill primary">Our Research Focus</span>
            <span className="stat-pill">Low-Latency Inference</span>
          </div>
        </div>
      </div>

      {/* Closed Loop Feedback Indicator */}
      <div className="loop-feedback-banner">
        <Activity className="feedback-icon" />
        <span><strong>Closed-Loop Optimization:</strong> Model predictions continuously adjust grid load balancing, natural gas dispatch, and compute scheduling to prevent physical bottlenecks and maximize efficiency.</span>
      </div>
    </div>
  );
};

export default InfrastructureDiagram;
